/* global $:true */
/*
Set Focus

Focus another element on a valid jquery event. By default this is `click`.


### Html Attributes

```
  data-focus-element
  data-focus-element--on="valid jquery event name"
  data-focus-element--target="[(scoping-directive)] .valid-jquery > selector"
  data-focus-element--delegate="true|false, bind event on element, or on document root"
  data-focus-element--ignore-child-events="true|false, child triggers events"
```

Markup:
<div class="u-align u-align--horizontal u-align--vertical-space-between" style="width: 20rem; height: 20rem;">
  <a class="u-focus u-focus--blue-light"
     href="#"
     id="GlobalJavascriptSetFocus">Focus target</a>
  <button
    data-focus-element
    data-focus-element--on="click"
    data-focus-element--target="#GlobalJavascriptSetFocus">A button</button>
</a>

Styleguide Global.Javascript.SetFocus
*/
import $ from 'jquery';

import debug from 'debug';
import plugin from '@core/plugins/lib';
import { ELEMENT_SELECTOR, PLUGIN_NAME } from './index';


const MODULE_NAME = 'plugins/focus-element';
const log = debug(MODULE_NAME);


log('registerd');

class PluginKlass {

  constructor(element, options) {
    log('new instance', element, options);

    this.element = element;
    this.options = options;

    this.$element = $(element);

    this.watch();

    log('ready', this.$element);
  }

  watch() {
    const { on, target, delegate } = this.options;
    if (on === '(now)') {
      this.focusTarget();
    } else if (!delegate) {
      this.boundEvent = this.$element
        .on(on, this.filterNonDelegateEvents(this.focusTarget));
    } else {
      $(document)
        .on(on, this.element, this.filterNonDelegateEvents(this.focusTarget));
    }
    log('watching', this.element, { on, target, delegate });
  }

  filterNonDelegateEvents(fn) {
    const {
      ignoreChildEvents
    } = this.options;
    return (event) => {
      if (ignoreChildEvents &&
        event.target !== this.element) {
        return;
      } else {
        fn.call(this);
      }
    };
  }

  focusTarget () {
    log('change');
    if (!this.options.target) {
      log('WARNING! missing focus-element `target` for ', this.$element);
    }
    const $target = this.selectors.selectTarget(this.options.target, this.$element);

    if (this.options.ifTarget && !$target.is(this.options.ifTarget)) {
      return;
    }

    log('change.targeting', $target);
    this.$element.trigger(`${PLUGIN_NAME}.source`);
    $target.focus();
    $target.trigger(`${PLUGIN_NAME}.target`);
  }

}

PluginKlass.DEFAULTS = {
  on: 'click',
  if: null, // conditional selector state of element
  ifTarget: null, // conditional selector state of target
  target: null,
  delegate: false, // bind on element or use delegate events on document.
  ignoreChildEvents: false, // whether or not child events trigger
};

plugin(PLUGIN_NAME, PluginKlass);



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__focus/plugin.js